export const useSubscriptionPlanCard = () => {
  const calculateMonthlyPrice = (
    price?: number | string | null,
    durationDays?: number | string | null
  ): number | null => {
    const numericPrice = Number(price);
    const numericDuration = Number(durationDays);

    if (
      !Number.isFinite(numericPrice) ||
      !Number.isFinite(numericDuration) ||
      numericDuration <= 0
    ) {
      return null;
    }

    const countOfMonths = Math.round(numericDuration / 30);
    const monthlyPrice = Math.round(numericPrice / countOfMonths);

    return monthlyPrice;
  };
  return {
    calculateMonthlyPrice,
  };
};
